import axios from "../axiosInstance";

class AutenticacaoService {
  async autenticarUsuario(idSessao, origemToken) {
    return axios.get("/autenticacao/" + idSessao + "/?authKey=" + origemToken);
  }

  async validarToken() {
    return axios.get("/autenticacao/validar-token");
  }

  async renovarToken() {
    return axios.get("/autenticacao/renovar-token");
  }

  async trocarEmpresa(siglaUsuario, idEmpresa) {
    return axios.get(
      "/autenticacao/trocar-empresa/?siglaUsuario=" + siglaUsuario + "&idEmpresa=" + idEmpresa
    );
  }
}

export default new AutenticacaoService();
